import { DialogTitle } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { ShiftPlanningShiftsPartner } from 'api';
import { useTranslation } from 'react-i18next';
import { BulkForwardDialogContent } from './dialog-content';
import { BulkForwardDialogActions } from './dialog-actions';
import { BulkForwardFormInput, SelectableFor } from '../types';

type Props = {
  availablePartners: ShiftPlanningShiftsPartner[];
  numberOfShifts: number;
  onSubmit: (data: BulkForwardFormInput) => void;
  closeDialog: () => void;
};

export const BulkForwardDialogForm = ({
  availablePartners,
  numberOfShifts,
  onSubmit,
  closeDialog,
}: Props) => {
  const formMethods = useForm<BulkForwardFormInput>();
  const { handleSubmit } = formMethods;
  const { t } = useTranslation('web-common');
  const selectableFor = availablePartners.length > 0 ? SelectableFor.All : SelectableFor.None;

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} data-testid="bulk-shift-forward">
        <DialogTitle>
          {t('bulk_actions.partner_forwarding.form_title', { ns: 'web-common' })}
        </DialogTitle>
        <BulkForwardDialogContent
          availablePartners={availablePartners}
          numberOfShifts={numberOfShifts}
          selectableFor={selectableFor}
        />
        <BulkForwardDialogActions selectableFor={selectableFor} closeDialog={closeDialog} />
      </form>
    </FormProvider>
  );
};
